import HeroSection from './components/HeroSection';
import ProductsSection from './components/ProductsSection';
import CatalogSection from './components/CatalogSection';
import RecipesSection from './components/RecipesSection';
import InstagramSection from './components/InstagramSection';
import NewsSection from './components/NewsSection';

const HomePage = () => {
  return (
    <div className="min-h-screen">
      <HeroSection />
      <ProductsSection />
      <CatalogSection />
      <RecipesSection />
      <InstagramSection />
      <NewsSection />
    </div>
  );
};

export default HomePage;